import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { getAWSUrl } from "../api/core";

const Fonts = (props) => {
  const font_list = JSON.parse(localStorage.getItem("font") || "[]");
  const initState = {
    selectedFont: font_list != null ? font_list.selectedFont : "Default",
    items: font_list != null ? font_list.items : [],
    urlItems: font_list != null ? font_list.urlItems : [],
  };

  const [fontSchema, setFont] = useState(initState);
  useEffect(() => {
    const getFontData = async () => {
      let data = await props.font;
      if (props.font != null) {
        setFont(data);
      }
    };
    getFontData();
  }, [props.font]);

  if (fontSchema.selectedFont === "Default") {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Roboto', sans-serif;}
         h1,h2,h3,h4,h5 { font-family: 'Roboto', sans-serif;}
         h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title { font-family: 'Roboto', sans-serif;}
         p,a { font-family: 'Roboto', sans-serif;}
         .big-title { font-family: 'Roboto', sans-serif; !important }

         `}</style>
      </Helmet>
    );
  } else if (fontSchema.selectedFont === "Classic") {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Quicksand', sans-serif;}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title { font-family: 'Roboto', sans-serif;}
         
         p,a,span,b { font-family: 'Quicksand', sans-serif;}
         .big-title { font-family: 'Roboto', sans-serif; !important }

         `}</style>
      </Helmet>
    );
  } else if (fontSchema.selectedFont === "Elegant") {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Lato', sans-serif;}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title{ font-family: 'Abril Fatface';}
         p,a,span,b { font-family: 'Lato', sans-serif}
         .big-title { font-family: 'Abril Fatface' !important; }
         `}</style>
      </Helmet>
    );
  } else if (fontSchema.selectedFont === "Modern") {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Roboto', sans-serif;}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title { font-family: 'Lato', sans-serif;}
         p,a,span,b { font-family: 'Roboto', sans-serif}
         .big-title {font-family: 'Lato', sans-serif !important;}

         `}</style>
      </Helmet>
    );
  } else if (fontSchema.selectedFont === "Fancy") {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Slabo 27px', serif;}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title {font-family: 'Ultra', serif;}
         p,a,span,b { font-family: 'Slabo 27px', serif;}
         .big-title {font-family: 'Ultra', serif !important; font-size:45px !important;}

         `}</style>
      </Helmet>
    );
  } else if (fontSchema.selectedFont === "Booklet") {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Merriweather', sans-serif;}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title {font-family: 'Oswald', sans-serif;}
         p,a,span,b { font-family: 'Merriweather', sans-serif;}
         .big-title {font-family: 'Oswald', sans-serif !important;}

         `}</style>
      </Helmet>
    );
  } else if (fontSchema.selectedFont === "Knox") {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Quicksand', sans-serif;}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title {font-family: 'Quicksand', sans-serif;}
         p,a,span,b { font-family: 'Quicksand', sans-serif;}
         .big-title {font-family: 'Quicksand', sans-serif !important;}

         `}</style>
      </Helmet>
    );
  } else if (
    fontSchema.selectedFont === "Custom URL Font" &&
    fontSchema.urlItems.length === 2
  ) {
    return (
      <Helmet>
        <style type="text/css">
          {`
        @import url('` +
            fontSchema.urlItems[0].itemFile +
            `');
         body { font-family: ` +
            fontSchema.urlItems[0].itemRef +
            `}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title {font-family: ` +
            fontSchema.urlItems[0].itemRef +
            `;font-weight:600}
         p,a,span,b { font-family: ` +
            fontSchema.urlItems[1].itemRef +
            `}
         .big-title {font-family: ` +
            fontSchema.urlItems[0].itemRef +
            ` !important}

         `}
        </style>
      </Helmet>
    );
  } else if (
    fontSchema.selectedFont === "Custom Font" &&
    fontSchema.items.length === 2
  ) {
    return (
      <Helmet>
        <style type="text/css">
          {`
        @font-face { font-family: Custom Heading; src: url(` +
            getAWSUrl() +
            fontSchema.items[0].itemFile +
            `) format('ttf'); }
        @font-face { font-family: Custom Para; src: url(` +
            getAWSUrl() +
            fontSchema.items[1].itemFile +
            `) format('ttf'); }
         body { font-family: Custom Heading}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title {font-family: Custom Heading;font-weight:700}
         p,a,span,b { font-family: Custom Para}
         .big-title {font-family: Custom Heading !important}

         `}
        </style>
      </Helmet>
    );
  } else {
    return (
      <Helmet>
        <style type="text/css">{`
         body { font-family: 'Roboto', sans-serif;}
         h1,h2,h3,h4,h5,h1 span,h2 span,h3 span,h4 span,h5 span,h1 a,h2 a,h3 a,h4 a,h5 a,.swiper-slide .content .title { font-family: 'Roboto', sans-serif;}
         p,a { font-family: 'Roboto', sans-serif;}
         .big-title {font-family: 'Roboto', sans-serif !important;}

         `}</style>
      </Helmet>
    );
  }
};

export default Fonts;
